import React, { useEffect, useState } from "react";
import Modal from "../../themed/modal";
import Confirm from "../../themed/confirm";

import { checkUserSessionExpired, MAX_AUTH_DURATION_IN_MINUTES } from "../../../services/cookieService";
import { getTimeDifference } from "../../../utils/utilities";

const AuthAlert: React.FC = () => {
    const [isAlertVisible, setAlertVisible] = useState(false);

    useEffect(() => {
        const interval = setInterval(() => {
            if (isAlertVisible) return;

            const { session } = checkUserSessionExpired();
            if (!session) return;

            const isAboutToExpire = getTimeDifference(session.timestamp, 'minute') >= (MAX_AUTH_DURATION_IN_MINUTES - 5);
            if (isAboutToExpire) setAlertVisible(isAboutToExpire);
        }, 60_000);

        return () => clearInterval(interval);
    }, [isAlertVisible]);

    return ( 
        <Modal style={{ height: "auto" }} isVisible={isAlertVisible} onClose={() => setAlertVisible(false)}>
            <div className="p-1">
                <Confirm
                    title="Warning"
                    message="Your session will expire in 5 minutes. Kindly save your work to avoid disruptions"
                    onConfirm={() => setAlertVisible(false)}
                />
            </div>
        </Modal>
    );
};
 
export default AuthAlert;